import Layout from '../views/layout/index.vue'
import i18n from '@/lang'
import { hasPermission } from '../plugins/permission-manager/manager'
import { PermissionKey } from '@pt/enums/user'
import { generateConfigRoute } from '@com/utils/generateConfigRoute'
import PtLayout from '@pt/views/layout/index.vue'

const makerPageRouter = [
  {
    path: 'custom/:customId(\\d+)',
    name: 'common-template.custom',
    component: () => import('@/views/creative/template'),
    meta: {
      title: i18n.t('playTurbo.versionlist.versionEdit'),
    },
  },

  {
    path: 'dco/:customId(\\d+)',
    name: 'common-template.dco',
    component: () => import('@/views/creative/template'),
    meta: {
      title: i18n.t('playTurbo.versionlist.versionEdit'),
    },
  },

  {
    path: 'multi-custom/:customId(\\d+)',
    name: 'common-template.multi-custom',
    component: () => import('@/views/creative/template'),
    meta: {
      title: i18n.t('playTurbo.versionlist.versionEdit'),
    },
  },
]
const tabTemplateRouter = [
  {
    path: 'lib',
    name: 'my-project.playable.change-template.lib',
    component: () => import('@pt/views/creative-template/playable/lib.vue'),
    meta: {
      title: i18n.t('playTurbo.home.playable.public'),
      defaultPath: '/my-project/playable',
      keys: ['gm'],
    },
  },
  {
    path: 'stars',
    name: 'my-project.playable.change-template.stars',
    component: () => import('@pt/views/creative-template/playable/stars.vue'),
    meta: {
      title: i18n.t('playTurbo.home.playable.collection'),
      defaultPath: '/my-project/playable',
      keys: ['gm'],
    },
  },
  {
    path: 'my-template',
    name: 'my-project.playable.change-template.my-template',
    component: () =>
      import('../views/pt-entry/my-project/playable/my-template.vue'),
    meta: {
      title: i18n.t('playTurbo.home.playable.template'),
      defaultPath: '/my-project/playable',
      keys: ['gm'],
    },
  },
]

const history = [
  {
    path: 'playable',
    name: 'my-project.history.playable',
    component: () => import('../views/pt-entry/my-project/history/playable'),
    meta: {
      title: '可玩项目',
      keys: ['gm', 'ps'],
      tab: 'playable',
      defaultPath: '/my-project/history',
    },
  },
  {
    path: 'video',
    name: 'my-project.history.video',
    component: () => import('../views/pt-entry/my-project/history/video'),
    meta: {
      title: '视频项目',
      keys: ['ve'],
      tab: 'video',
      defaultPath: '/my-project/history',
    },
  },
  {
    path: 'record',
    name: 'my-project.history.record',
    component: () => import('../views/pt-entry/my-project/history/record'),
    meta: {
      title: '录屏项目',
      keys: ['vrec'],
      tab: 'record',
      defaultPath: '/my-project/history',
    },
  },
  {
    path: 'ai',
    name: 'my-project.history.ai',
    component: () => import('../views/pt-entry/my-project/history/ai.vue'),
    meta: {
      title: 'ai视频项目',
      keys: [PermissionKey.AIGC],
      tab: 'ai',
      defaultPath: '/my-project/history',
    },
    children: [
      {
        path: '',
        name: 'my-project.history.ai.task',
        component: () =>
          import(
            '../views/pt-entry/components/ai-history-export/task-list.vue'
          ),
        meta: {
          title: 'ai视频项目',
          keys: [PermissionKey.AIGC],
          tab: 'ai',
          type: 'task',
          defaultPath: '/my-project/history',
        },
      },
      {
        path: 'work',
        name: 'my-project.history.ai.work',
        component: () =>
          import(
            '../views/pt-entry/components/ai-history-export/work-list.vue'
          ),
        meta: {
          title: 'ai视频项目',
          keys: [PermissionKey.AIGC],
          tab: 'ai',
          type: 'work',
          defaultPath: '/my-project/history',
        },
      },
    ],
  },
]

export default {
  path: '/my-project',
  component: Layout,
  redirect: 'noredirect',
  name: 'my-project',
  icon: 'project_1',
  meta: {
    title: i18n.t('playTurbo.leftMenu.aside.menu.myproject.name'),
    // elicon: 'el-icon-fa-bar-chart',
    // roles: [],
  },
  children: [
    {
      path: 'playable',
      name: 'my-project.playable',
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.myproject.playable'),
      },
      redirect: (to) => {
        return {
          path: `/my-project/playable/${
            to.query.project_type ? to.query.project_type : 'normal'
          }`,
          query: to.query,
        }
      },
    },
    {
      path: 'playable/normal',
      name: 'my-project.playable.normal',
      component: () => import('../views/pt-entry/my-project/playable'),
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.myproject.playable'),
        defaultPath: '/my-project/playable',
        keys: ['gm'],
      },
      to: {
        query: {
          project_type: 'normal',
        },
      },
      hidden: true,
    },
    {
      path: 'playable/playsmart',
      name: 'my-project.playable.playsmart',
      component: () => import('../views/pt-entry/my-project/playable'),
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.myproject.playable'),
        defaultPath: '/my-project/playable',
        keys: ['ps'],
      },
      to: {
        query: {
          project_type: 'playsmart',
        },
      },
      hidden: true,
    },
    {
      path: 'playable/iv',
      name: 'my-project.playable.interactive',
      component: () => import('../views/pt-entry/my-project/playable'),
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.myproject.playable'),
        defaultPath: '/my-project/playable',
        keys: ['gm'],
      },
      to: {
        query: {
          project_type: 'iv',
        },
      },
      hidden: true,
    },
    generateConfigRoute(
      {
        title: i18n.t('playTurbo.leftMenu.aside.menu.myproject.videoAndImage'),
        pageId: 'project_url2image',
      },
      {
        routeConfig: {
          component: PtLayout,
        },
        metaConfig: {
          keys: [PermissionKey.Ve, PermissionKey.International],
        },
      },
    ),
    generateConfigRoute(
      {
        title: i18n.t('playTurbo.videoProject.title').toString(),
        pageId: 'video_project',
      },
      {
        routeConfig: {
          component: PtLayout,
        },
        metaConfig: {
          keys: [PermissionKey.Ve, PermissionKey.International],
        },
      },
    ),
    {
      path: 'playable/change-template',
      redirect: 'playable/change-template/lib',
      name: 'my-project.playable.change-template',
      hidden: true,
      component: () =>
        import('../views/pt-entry/my-project/playable/change-template'),
      meta: {
        title: '选择模版',
        defaultPath: '/my-project/playable',
        keys: ['gm'],
      },
      children: [...tabTemplateRouter],
    },
    {
      path: 'playable/:templateId(\\d+)',
      name: 'common-template.templateId',
      component: {
        template: `<router-view></router-view>`,
      },
      hidden: true,
      meta: {
        title: i18n.t('playTurbo.versionlist.versionmanage'),
      },
      children: [...makerPageRouter],
    },

    {
      path: 'history',
      name: 'my-project.history',
      component: () => import('../views/pt-entry/my-project/history'),
      redirect: () => {
        const target =
          history.find((item) => hasPermission(item.meta.keys, 'or')) ||
          history[0]
        return { name: target.name }
      },
      meta: {
        title: i18n.t('playTurbo.leftMenu.aside.menu.myproject.export'),
        defaultPath: '/my-project/history',
      },
      children: history,
    },
  ],
}
